var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fam-hero",class:{ 'fam-hero-lg': _vm.large }},[_c('div',{staticClass:"fam-hero-bg"}),_c('div',{staticClass:"fam-hero-content"},[_c('div',{staticClass:"fam-hero-title"},[_vm._v(_vm._s(_vm.title))]),(_vm.sub)?_c('div',{staticClass:"fam-hero-sub"},[_vm._v(_vm._s(_vm.sub))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }